<template>
  
<div class="row justify-content-center">
    <div class="col-12 col-md-6 engineering-paper">
        <div class="col-auto mb-3">
            <RouterLink to="/" class="home-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="black">
                <path d="M10 20v-6h4v6h6v-8h3L12 3 2 12h3v8z"/>
              </svg>
          </RouterLink>
        </div>
        <h5>About EngSheet</h5>
        
        <p class="mb-3">
        EngSheet, is a collection of structural engineering calculation tools built with passion and precision. 
        I'm a structural engineer and programmer who believes that good engineering software should be transparent, 
        accessible, and built by engineers for engineers.
        </p>

        <h5>My Journey</h5>
        <div class="row mb-3">
          <div class="col-12">
            <p>
            My programming journey began at the University of Toronto, where I worked as a teaching assistant and MASc student, 
            developing a subroutine for Vector2—a non-linear finite element software (<a href="http://vectoranalysisgroup.com/" target="_blank" class="text-decoration-none text-dark border-bottom border-dark">vectoranalysisgroup.com</a>). 
            This experience ignited my passion for combining structural engineering with software development.
            </p>
          </div>
        </div>
        <div class="text-center mb-3">
          <img src="@/assets/images/portrait.jpg" alt="Working on engineering projects" class="img-fluid about-img" />
        </div>

        <p class="mb-3">
        That passion evolved into full-stack web development when I created a resource management SaaS for my former company 
        using Laravel and Vue.js. Currently, I'm developing ETABSPY and SAFEPY—Python programs that connect to ETABS and SAFE 
        to retrieve structural analysis data and automate design tasks such as shear wall design and slab design, leveraging 
        data science libraries like NumPy, SciPy, and Matplotlib for analysis and visualization. EngSheet continues this journey, 
        built as a single-page application with Vue.js that runs blazingly fast and works seamlessly in the browser, with 
        interactive visualizations powered by D3.js.
        </p>

        <h5>The Technology Behind EngSheet</h5>
        <p class="mb-3">
        What makes EngSheet sophisticated is its underlying architecture. The calculators are generated using a self-developed 
        LLM pipeline that transforms individual code clauses and personalized explanations into working algorithms. This approach 
        has been instrumental in accelerating the development of accurate, code-compliant calculators.
        </p>

        <p class="mb-3">
        My ultimate goal is to make this process seamless—imagine uploading a hand-calculated example or a design code excerpt 
        and having it automatically converted into a calculator. While tools like ChatGPT and Claude.ai can already do this to 
        some extent, they have their caveats, and the final product requires extensive testing and verification. EngSheet aims 
        to bridge this gap with a purpose-built system designed specifically for structural engineering calculations.
        </p>

        <h5>My Passion for Running</h5>
        <div class="row mb-3">
          <div class="col-12">
            <p>
            Running has become a big part of who I am. What started as just a way to stay active slowly turned into something I 
            actually look forward to — a space to think, reset, and challenge myself. There's something about the rhythm of running 
            that helps me find focus; it clears my head and reminds me that progress usually comes one step at a time. I'm not 
            chasing records — I'm chasing consistency. Whether I'm training for a 5K or just getting out for a quick evening run, 
            it's where I test my limits, process my thoughts, and find a bit of balance in everything else going on.
            </p>
            <p>
            You can follow my runs and training journey on 
            <a href="https://www.strava.com/athletes/22189047" target="_blank" rel="noopener noreferrer" class="text-decoration-none text-dark border-bottom border-dark">Strava</a>.
            </p>
          </div>
        </div>
        <div class="text-center mb-3">
          <img src="@/assets/images/running.jpg" alt="Running" class="img-fluid about-img" />
        </div>

        <h5>Staying Active: Boxing, Tennis, and the Gym</h5>
        <p class="mb-3">
        Beyond running, I stay active through boxing, tennis, and regular gym sessions. Boxing teaches me discipline and focus—every 
        round demands presence and precision. Tennis brings out my competitive side while keeping things fun and social. The gym ties 
        it all together, building the strength and endurance that support everything else. These activities aren't just about fitness; 
        they're about maintaining balance, pushing boundaries, and finding different ways to challenge myself physically and mentally.
        </p>

        <h5>My Passion for Piano</h5>
        <div class="row mb-3">
          <div class="col-12">
            <p>
            Playing piano has always been a personal escape for me — a way to slow down and express thoughts that words can't quite 
            capture. I'm drawn to how a few keys and chords can shift a whole mood, and how much focus and patience it takes to bring 
            a piece to life. It's where I learn balance between precision and creativity, discipline and emotion. Whether I'm learning 
            a new song or just improvising, piano is my reset button — something that keeps me grounded while letting my mind wander 
            freely.
            </p>
          </div>
        </div>
        <div class="text-center mb-3">
          <!-- <img src="@/assets/images/piano.jpg" alt="Playing piano" class="img-fluid about-img" /> -->
        </div>
        
        <!-- <p class="mt-3 fst-italic" style="font-size: 0.75rem;">
        More calculators are in development. Each tool is carefully crafted to follow code requirements and engineering 
        best practices.
        </p> -->
    </div>
</div>

</template>

<script>

export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about-img {
  border-radius: 4px;
  max-width: 200px !important;
  height: auto;
}

h5 {
  text-decoration: underline;
}

p {
  text-align: justify;
}
</style>